import { type ComponentType, lazy } from 'react';

/**
 * Permite importar un componente en forma dinámica con ruta relativa a
 * /customComponents
 */
export function importComponent<T = unknown>(path: string) {
  return lazy<ComponentType<T>>(() => {
    return new Promise<{
      default: ComponentType<T>;
    }>((resolve) => {
      import(/* webpackInclude: /\.tsx?$/ */ `/customComponents/${path}`)
        .then((result: { default: { default: ComponentType<T> } }) => {
          resolve(result.default);
        })
        .catch((error: unknown) => {
          resolve({
            default: () => {
              console.error(error);
              return <>Error</>;
            },
          });
        });
    });
  });
}
